import React from "react";
import Widget from "components/Widget";
import SymptomList from "components/Table/List";
import ActionMenu from "components/Table/Actions/ActionDropdown";
import Layout from "components/Layout";
import DeleteConfirm from "components/Modal/DeleteConfirm";
import EditSymptom from "./components/EditSymptoms";
import ShowModal from "components/Modal/ShowModal";
import AddNewSymptom from "./components/AddSymptoms";
import SearchBox from "components/Filters/SearchBox";
import UploadCSV from "components/uploadCSV";
import { Tag } from "antd";
const Symptom = () => {
  const columns = [
    {
      title: "Name",
      render: (record) => <span>{record.symptomName}</span>,
      key: "Name",
    },

    {
      title: " ",
      render: (record) => <ActionMenu menu={renderActions(record)} />,
      key: "action",
      width: "50px",
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"Edit_Symptom_Modal"}
          buttonName="Edit"
        />
        <DeleteConfirm
          type="deleteSymptom"
          recordName="symptomList"
          method="DELETE"
          selectedItem={record}
          apiRequest="DeleteRecord"
          buttonName="Yes"
          oKText="Delete"
          title="Are you sure you want to delete this symptom?"
          content=""
          Icon="Delete"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title={
          <div className="gx-d-flex gx-flex-column">
            <span>SYMPTOMS</span>
            <a
              className="gx-m-0"
              href="https://painles.s3.amazonaws.com/1654281755467-symptomName-1%20-%20Sheet1.csv"
            >
              <Tag className="gx-m-0" color="blue">
                Download CSV Sample
              </Tag>
            </a>
          </div>
        }
        extra={
          <div className="gx-d-flex" style={{ gap: "20px" }}>
            <SearchBox
              apiName="getSymptoms"
              recordName="symptomList"
              requestType="FetchRecord"
              customQuery={{ query: "search", key: "name" }}
              placeholder="Search By Name"
              width="200px"
            />
            <UploadCSV
              type="getSymptoms"
              url="bulkImportSkills"
              table="Symptom"
              recordName="symptomList"
              cb="symptomName"
              uId="symptomId"
            />
            <AddNewSymptom />
          </div>
        }
      >
        <SymptomList
          recordName="symptomList"
          apiName="getSymptoms"
          columns={columns}
          scroll={true}
          pagination={true}
        />
      </Widget>
      <EditSymptom />
    </Layout>
  );
};

export default Symptom;
